import { Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { type NoteCategory } from "../../types/lead.types.ts"
import { NOTE_CATEGORY_COLORS } from "./note-category-colors.ts"

const { Text } = Typography

interface NoteCategoryChipProps {
  category: NoteCategory
  /** "chip" is a compact pill for the List table; "label" is subordinate
   *  colored text for the Board card, closer to a handwritten tag than a
   *  badge. */
  variant?: "chip" | "label"
}

function NoteCategoryChip({
  category,
  variant = "chip"
}: NoteCategoryChipProps) {
  const { t } = useTranslation()
  const colors = NOTE_CATEGORY_COLORS[category]
  const label = t(`leadWorkspace.cards.notes.category.${category}`)

  if (variant === "label") {
    return (
      <Text
        className={"text-[11px] font-semibold uppercase tracking-wide"}
        style={{ color: colors.text }}
      >
        {label}
      </Text>
    )
  }

  return (
    <span
      className={
        "inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium"
      }
      style={{
        backgroundColor: colors.background,
        borderColor: colors.border,
        color: colors.text
      }}
    >
      {label}
    </span>
  )
}

export { NoteCategoryChip }
